import * as React from 'react';
import { SVGProps } from 'react';
const SvgError = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.9999 7.00051H12.9999V14.0005H10.9999V7.00051ZM10.9999 15.0005H12.9999V17.0005H10.9999V15.0005Z"
      fill="current"
    />
    <path
      d="M21.9999 7.58651L16.4139 2L7.58576 2.00051L7.58477 2.0015L2.0001 7.58636L1.99805 16.4154H2.00072L7.58587 22.0005L16.4144 22L22 16.4144L21.9999 7.58651ZM19.9999 15.5865L15.5859 20.0005H8.41386L3.99986 15.5865V8.41451L8.41386 4.00051H15.5859L19.9999 8.41451V15.5865Z"
      fill="current"
    />
  </svg>
);
export default SvgError;
